<!-- TEMPLATE -->
<template>
  <div class="dean-sidemenu-column column-flex">
    <div :class="deanSidemenuClass">
      <dean-section-title v-if="!titleBar" :theme="theme" mobile-button>
        <span
          slot="mobile-button"
          class="dean-sidemenu-mobile-button small-12 medium-0 large-0 hd-0 columns"
          v-if="data.title.mobile"
        >
          <dean-section-title-item
            :tooltip="false"
            v-for="item in data.title.mobile"
            @click.native="deanSidemenuMobileItemClick(item.text)"
            :key="String(item.text)"
            :icon="item.icon"
            :theme="theme"
          >
            {{ item.text }}
          </dean-section-title-item>
        </span>
        <span slot="title">
          {{ data.title.text }}
        </span>
        <span v-if="data.title.buttons" class="dean-sidemenu-top-buttons">
          <dean-section-title-item
            class="top-button"
            v-for="item in data.title.buttons"
            @click.native="deanSidemenuTitleItemClick(item.text)"
            :key="String(item.text)"
            :icon="item.icon"
            :theme="theme"
          >
            {{ item.text }}
          </dean-section-title-item>
        </span>
      </dean-section-title>
      <div
        v-if="titleBar" 
        class="title-bar">
        <p>{{ data.title.text }}</p>
          <dean-icon
            class="close-menu"
            :glyph="closeIcon"
            :height="40"
            :width="40"
            @click.native="deanSidemenuCloseClick"
          ></dean-icon>
      </div>
      <span v-for="section in data.sections" :key="String(section.title)">
        <dean-section-divider v-if="section.title" sidemenu>{{
          section.title
        }}</dean-section-divider>
        <span v-for="item in section.items" :key="String(item.title)">
          <dean-sidemenu-column-item
            v-if="item.disabled || item.readonly"
            :icon="item.icon"
            :disabled="item.disabled"
            :readonly="item.readonly"
            :hidden="item.hidden"
          >
            {{ item.title }}
          </dean-sidemenu-column-item>
          <dean-sidemenu-column-item
            v-else
            :icon="item.icon"
            :active="item.active"
            :state="item.state"
            :hidden="item.hidden"
            @click.native="deanSidemenuItemClick(item)"
          >
            {{ item.title }}
          </dean-sidemenu-column-item>
        </span>
      </span>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanButton from './deanButton.vue';
import deanButtonGroup from './deanButtonGroup.vue';
import deanSectionTitle from './deanSectionTitle.vue';
import deanSectionTitleItem from './deanSectionTitleItem.vue';
import deanSectionDivider from './deanSectionDivider.vue';
import deanSidemenuColumnItem from './deanSidemenuColumnItem.vue';
import deanIcon from './deanIcon.vue';

//SVG
import closeIcon from '../svg/feather-icons/x.svg';

@Component({
  components: {
    deanButton,
    deanButtonGroup,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSectionDivider,
    deanSidemenuColumnItem,
    deanIcon
  }
})
export default class deanSidemenuColumn extends Vue {
  //PROPS
  @Prop() data!: object;
  @Prop() theme!: string;
  @Prop({ default: false }) themed!: boolean;
  @Prop({ default: false }) titleBar!: boolean;
  
  closeIcon: object = closeIcon;

  //COMPUTED
  get deanSidemenuClass() {
    let value = 'dean-sidemenu-column-bar';
    if (this.themed) value += ` themed`;
    if (this.theme) {
      value += ` ${this.theme}`;
    }
    return value;
  }

  //METHODS
  deanSidemenuItemClick(item: object) {
    this.$emit('dean-sidemenu-item-click', item);
  }

  deanSidemenuTitleItemClick(item: string) {
    this.$emit('dean-sidemenu-title-item-click', item);
  }

  deanSidemenuMobileItemClick(item: string) {
    this.$emit('dean-sidemenu-mobile-item-click', item);
  }

  deanSidemenuCloseClick(item: string) {
    this.$emit('close');
  }

  mounted() {
    console.log(this.data)
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN SIDEMENU
.dean-sidemenu-column {
  position: relative;
  display: inline-flex;
  min-height: 100%;

  .dean-sidemenu-column-bar {
    position: relative;
    min-height: 100%;
    min-width: 100%;
    color: black;
    background: white;
    border-right: 1px solid var(--color-light-shade-2, $color-light-shade-2);
  }

  .themed {
    color: black;
    background: var(--color-light-shade-3, $color-light-shade-3);
    //border-right: 1px solid var(--color-light-shade-3, $color-light-shade-3);
  }

  @media #{$small-only} {
    display: block;
    min-width: 100%;
  }

  .title-bar {
    @include display-flex();
    position: relative;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    color: white;
    background: var(--color-dark-shade-4, $color-dark-shade-4);
    // background: var(--color-primary, $color-primary); ;
    // background: var(--color-light-shade-3, $color-light-shade-3);
    margin-bottom: 10px;
    padding: 10px 10px 10px 10px;
    p {
      display: inline-flex;
      padding: 0;
      word-break: break-word;
      text-align: left;
      font-weight: 500;
      font-size: $font-heading-small;
    }
    &:after {
      position: absolute;
      top: 0px;
      left: 0px;
      content: '';
      min-width: 35px;
      min-height: 5px;
      background: var(--color-secondary, $color-secondary);
    }
    .close-menu {
      display: none;
      //background: var(--color-light-shade-2, $color-light-shade-2);
      fill: var(--color-light-shade-2, $color-light-shade-2); //var(--color-dark, $color-dark);
      cursor: pointer;
      padding: 10px;
      @include transition(0.8s);
      @include border-radius(100px);
      &:hover {
        fill: var(--color-primary, $color-primary);
      }
      @media #{$small-only} {
        display: inline-flex;
      }
    }
  }
}
</style>
